import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
const uiModule = namespace('ui');
let NavigationDrawer = class NavigationDrawer extends Vue {
    get darkSideItemColors() {
        return this.$vuetify.theme.dark ? {} : {
            'active-class': 'primary--text',
            ripple: { 'class': 'primary--text' }
        };
    }
    hasSubItems({ items }) {
        return items && items.length;
    }
    buildComponentProps(item) {
        return this.hasSubItems(item) ? {
            is: 'v-list-group',
            color: this.$vuetify.theme.dark ? '' : 'primary',
            class: 'listGroupHeader',
            ripple: false
        } : {
            is: 'v-list-item',
            exact: item.route === this.baseRoute,
            to: item.route,
            ...this.darkSideItemColors
        };
    }
};
__decorate([
    uiModule.State
], NavigationDrawer.prototype, "isSideBarOpen", void 0);
__decorate([
    uiModule.Action
], NavigationDrawer.prototype, "updateSideBar", void 0);
__decorate([
    Prop(Array)
], NavigationDrawer.prototype, "items", void 0);
__decorate([
    Prop(String)
], NavigationDrawer.prototype, "baseRoute", void 0);
NavigationDrawer = __decorate([
    Component
], NavigationDrawer);
export default NavigationDrawer;
